import React from 'react';
import PropTypes from 'prop-types';
import { addSkill, removeSkill, updateComplianceDraft } from '../../actions/ComplianceActionCreator';
import TextField from '../Common/TextField';
import { Form as FormsyForm } from 'formsy-react';
import EditSkillList from '../Skill/EditSkillList';

const ComplianceForm = ({draft, onSave, onDiscard, onUpdate, onAddSkill, onRemoveSkill, ...props}) => {
    return (
        <FormsyForm className="cent-flex-row">
            <div className="cent-col-1">
                <TextField
                    name="name"
                    value={draft.name}
                    validations="minLength:1,maxLength:80"
                    validationError="Please use only numbers and letters, at least 1"
                    hintText="Name"
                    fullWidth={true}
                    floatingLabelText="Name"
                    onChange={(e, value) => onUpdate('name', value)}
                    required
                />
            </div>
            <div className="cent-col-1">
                <EditSkillList
                    skills={draft.skills}
                    onAdd={(name, id) => onAddSkill({id, name})}
                    onRemove={onRemoveSkill}
                />
            </div>
        </FormsyForm>
    );
};

ComplianceForm.propTypes = {
    draft: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
    }),
    onUpdate: PropTypes.func,
    onAddSkill: PropTypes.func,
    onRemoveSkill: PropTypes.func,
};

ComplianceForm.defaultProps = {
    onUpdate: updateComplianceDraft,
    onAddSkill: addSkill,
    onRemoveSkill: removeSkill,
};

export default ComplianceForm;
